import React from 'react';

import { StyledCustomLoader } from './styled';

export const CustomLoader: React.FC = () => {
    return (
        <StyledCustomLoader className="loader">
            <span className="circle"></span>
            <span className="circle"></span>
            <span className="circle"></span>
            <span className="circle"></span>
        </StyledCustomLoader>
    );
};
